import axios from "axios";

// 🔹 Loader reference (used to trigger loader from non-React Axios file)
export const loaderRef = {
  show: () => {},
  hide: () => {},
};

// 🔹 Functions to connect React context's setLoading()
export const setLoaderFunctions = (showFn, hideFn) => {
  loaderRef.show = showFn || (() => {});
  loaderRef.hide = hideFn || (() => {});
};

// 🔹 Define your release number
const RELEASE_NO = "0.0.7"; 

// 🔹 Create Axios instance
const AxiosInstance = axios.create({
  // baseURL: "https://test.bharatclouds.com",
  // baseURL: "https://dev.bharatclouds.com",
  baseURL: "https://bharatclouds.com",
});

// 🔹 Request interceptor
AxiosInstance.interceptors.request.use(
  (config) => {
    loaderRef.show();

    // Send release number in Authorization header
    config.headers["Authorization"] = `${RELEASE_NO}`;

    return config;
  },
  (error) => {
    loaderRef.hide();
    return Promise.reject(error);
  }
);

// 🔹 Response interceptor
AxiosInstance.interceptors.response.use(
  (response) => {
    loaderRef.hide();
    return response;
  },
  (error) => {
    loaderRef.hide();

    if (error.response && error.response.status === 403) {
      console.warn("403 Forbidden error – reloading the page...");
      window.location.reload(); // 🔄 Force hard reload
    }

    return Promise.reject(error);
  }
);

// 🔹 Export
export { AxiosInstance };
